import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';
import { DialogService } from '@core/services/dialog.service';
import { Observable } from 'rxjs';
import { HeaderPageSignalDataService } from '../header-page-signal-data.service';
import { MessageService } from '@core/services/message.service';
import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import * as utc from 'dayjs/plugin/utc';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';

dayjs.extend(duration);
dayjs.extend(utc);
@Component({
  selector: 'app-menu-header',
  templateUrl: './menu-header.component.html',
  styleUrls: ['./menu-header.component.scss']
})
export class MenuHeaderComponent implements OnInit {

  isLoggedIn$!: Observable<boolean>;
  nomeUsuario: string | undefined;
  perfil: string | undefined;
  isCollapsed: boolean = false;

  sessaoInterval: any;
  tempoSessao: string | undefined;
  timeLimitExpire: string = '02:00';
  versionTimerVerify: number[] = [10, 13, 15, 18];
  countHour: number = 0;
  countNotas: number = 0;

  constructor(
    private authenticationService: AuthenticationService,
    public headerPageSignalDataService: HeaderPageSignalDataService,
    public appSignalDataService: AppSignalDataService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NzModalService,
  ) {
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
  }

  ngOnInit() {
    this.carregarDados();
    this.sessaoTimer();
  }

  sessaoTimer() {
    this.authenticationService.currentDataExpiracao.subscribe(() => {
      if (dayjs(this.authenticationService.dataExpiracaoAcesso)) {
        if (this.sessaoInterval) {
          clearInterval(this.sessaoInterval);
        }

        this.sessaoInterval = setInterval(() => {
          const date = dayjs(this.authenticationService.dataExpiracaoAcesso);
          const diff = dayjs.duration(date.diff(dayjs()));
          this.tempoSessao = dayjs.utc(diff.asMilliseconds()).format('HH:mm:ss');

          let inScore = this.appSignalDataService.showScore$();
          if (this.tempoSessao == this.timeLimitExpire && inScore || this.tempoSessao == '00:10' && inScore) {
            this.resetTempoSessao();
          }


          if (this.tempoSessao == this.timeLimitExpire && !inScore) {
            const dlg = this.dialogService.confirm('Seu tempo de acesso está expirando!\nDeseja atualizar o seu login?', () => this.resetTempoSessao());
            setTimeout(() => dlg.destroy(), 60000);
          }

          if (date.toDate() <= dayjs().toDate() || this.tempoSessao == '00:00') {
            clearInterval(this.sessaoInterval);
            this.authenticationService.logout();
          }
        }, 1000);
      }
    });
  }

  carregarDados() {
    this.nomeUsuario = this.authenticationService.currentUserValue?.nome;
    this.perfil = this.authenticationService.currentUserValue?.perfil?.perfil.toLowerCase();
  }

  resetTempoSessao() {
    this.authenticationService.prolongateToken().subscribe(data => this.messageService.success('Login atualizado com sucesso!!!'));
  }

  logout(): void {
    this.dialogService.confirm('Deseja realmente sair do sistema?', () => {
      this.authenticationService.logout(undefined, undefined, true);
    });
  }


  centralDeInformacoes(): void {
    this.router.navigate(['central-informacao']);
  }


  faq(): void {
    this.router.navigate(['faq']);
  }

  ngOnDestroy(): void {
    if (this.sessaoInterval) {
      clearInterval(this.sessaoInterval);
    }
  }
}
